import React from 'react';
import { getPublicSystemStrings } from './publicFunnelLanguage';

/**
 * WEB-1988 — прелоадер публичной воронки.
 *
 * Повторяет разметку кит-прелоадера (`components/kit/Preloader.tsx`,
 * ратифицированный канон shared-kit-mockup: кольцо 28px, те же паддинги и
 * keyframes) БЕЗ Ant Design. Кит берёт цвета из `theme.useToken()` и подпись
 * из `Typography.Text` — оба импорта тянут в граф весь antd, а публичный вход
 * обязан быть от него свободен (сторож `src/build-guards/publicEntryGuard.ts`).
 * Цвета здесь — те же CSS-переменные, что стоят за токенами кита
 * (`styles/global.css`), поэтому вид совпадает.
 *
 * Подпись для читалки с экрана берётся из ОБЩЕГО словаря (`commonStrings`,
 * пара ru/en) через `pickStrings`, а не хуком: прелоадер показывается в том
 * числе до того, как поднялось дерево провайдеров.
 */
export interface PublicPreloaderProps {
  /** Подпись под кольцом. */
  label?: React.ReactNode;
  /** Компактные отступы (инлайн в карточках). */
  compact?: boolean;
  'data-testid'?: string;
}

export function PublicPreloader({
  label,
  compact,
  ...rest
}: PublicPreloaderProps): React.ReactElement {
  // Ревизия пачки 33 (WEB-2022, второй конец): подпись для читалки — из словаря
  // ВОРОНКИ на языке покупателя, не из словаря кабинета (ru/en).
  const common = { loading: getPublicSystemStrings().loadingLabel };
  const testId = rest['data-testid'] ?? 'preloader';

  return (
    <div
      role="status"
      aria-label={common.loading}
      data-testid={testId}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        padding: compact ? '32px 16px' : '64px 24px',
      }}
    >
      <style>{'@keyframes w2aSpin { to { transform: rotate(360deg); } }'}</style>
      <span
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          border: '3px solid var(--color-bg-tertiary, rgba(0, 0, 0, 0.06))',
          borderTopColor: 'var(--color-primary, #4094F7)',
          animation: 'w2aSpin 0.8s linear infinite',
        }}
      />
      {label && (
        <span
          style={{
            fontSize: 13,
            color: 'var(--color-text-secondary, rgba(0, 0, 0, 0.65))',
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
}

export default PublicPreloader;
